import { ForgotPasswordComponent } from "./views/forgot-password/forgot-password.component";
import { ChangePasswordComponent } from "./views/change-password/change-password.component";
import { ProductAuthenticationComponent } from "./views/product-authentication/product-authentication.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { LoginComponent } from "./views/login/login.component";
import { LoginNewComponent } from "./views/login-new/login-new.component";
import { DefaultLayoutComponent } from "./containers/default-layout/default-layout.component";
import { AuthGuardService } from "./services/auth-guard.service";
import { P404Component } from "./views/error/p404/p404.component";
import { TncComponent } from "./views/tnc/tnc.component";
import { HIProductAuthenticationComponent } from "./views/hi-product-authentication/hi-product-authentication.component";
import { MPPKVVCLAuthenticationComponent } from "./views/mppkvvcl-authentication/mppkvvcl-authentication.component";
import { JkProdAuthComponent } from "./views/jk-prod-auth/jk-prod-auth.component";
import { RazzleDazzleComponent } from "./views/razzle-dazzle/razzle-dazzle.component";
import { HilProductAuthenticationComponent } from "./views/hil-product-authentication/hil-product-authentication.component";
import { IssueNoProductAuthenticationComponent } from "./views/issue-no-product-authentication/issue-no-product-authentication.component";
import { TnProductAuthenticationComponent } from "./views/tn-product-authentication/tn-product-authentication.component";
import { RedeemLoyaltyComponent } from "./views/redeem-loyalty/redeem-loyalty.component";
import { CPHIPMECComponent } from "./views/cphi-pmec/cphi-pmec.component";
import { ExperimentalAuthenticationComponent } from "./views/experimental-authentication/experimental-authentication.component";
import { ProductAuthWaComponent } from "./views/product-auth-wa/product-auth-wa.component";
import { PfhpplComponent } from "./views/pfhppl/pfhppl.component";
import { BharatBiriAuthComponent } from "./views/bharat-biri-auth/bharat-biri-auth.component";
import { ForgotPasswordTrendComponent } from "./views/forgot-password-trend/forgot-password-trend.component";
import { PrAuthComponent } from "./views/pr-auth/pr-auth.component";
import { ForgetPasswordArmicaComponent } from "./views/forget-password-armica/forget-password-armica.component";
import { AnalyticsComponent } from "./views/analytics/analytics.component";
import { ProductIntelligenceComponent } from "./views/product-intelligence/product-intelligence.component";
import { GeneratedQrReportComponent } from "./views/generated-qr-report/generated-qr-report.component";
import { InventoryReportComponent } from "./views/inventory-report/inventory-report.component";
import { RecentAlertsReportComponent } from "./views/recent-alerts-report/recent-alerts-report.component";
import { ConfigurationComponent } from "./views/configuration/configuration.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard1",
    pathMatch: "full",
  },
  {
    path: "daashboard_new",
    redirectTo: "dashboard/daashboard_new",
    pathMatch: "full",
  },
  {
    path: "dashboard_new",
    redirectTo: "dashboard/dashboard_new",
    pathMatch: "full",
  },
  {
    path: "404",
    component: P404Component,
    data: {
      title: "Page 404",
    },
  },
  {
    path: "CPHI-PMEC",
    component: CPHIPMECComponent,
    data: {
      title: "CPHI-PMEC",
    },
  },
  {
    path: "pfhppl",
    component: PfhpplComponent,
    data: {
      title: "pfhppl",
    },
  },
  {
    path: "redeem-loyalty",
    component: RedeemLoyaltyComponent,
    data: {
      title: "Redeem Loyalty",
    },
  },
  {
    path: "login",
    component: LoginNewComponent,
    data: {
      title: "Login Page",
    },
  },
  {
    path: "login1",
    component: LoginComponent,
    data: {
      title: "Login Page",
    },
  },
  // {
  //   path: 'razzle-dazzle',
  //   component: RazzleDazzleComponent,
  //   data: {
  //     title: 'Razzle Dazzle'
  //   }
  // },
  {
    path: "forgotpassword",
    component: ForgotPasswordComponent,
    data: {
      title: "Forgot Password",
    },
  },
  {
    path: "forgotpasswordtrend",
    component: ForgotPasswordTrendComponent,
    data: {
      title: "Forgot Password Trend",
    },
  },
  {
    path: "forgotpasswordarmica",
    component: ForgetPasswordArmicaComponent,
    data: {
      title: "Forgot Password Armica",
    },
  },
  {
    path: "pa",
    component: ProductAuthenticationComponent,
    data: {
      title: "Authentication Page",
    },
  },
  {
    path: "pr",
    component: PrAuthComponent,
    data: {
      title: "Authentication Page",
    },
  },
  {
    path: "bharat-biri-auth",
    component: BharatBiriAuthComponent,
    data: {
      title: "Bharat Biri Authentication Page",
    },
  },
  {
    path: "jk",
    component: JkProdAuthComponent,
    data: {
      title: "Authentication Page",
    },
  },
  // for sa.holostikapp.com only. When Deploying there uncomment it
  // {
  //   path: "hil",
  //   component: HilProductAuthenticationComponent,
  //   data: {
  //     title: "Authentication Page",
  //   },
  // },
  {
    path: "hi",
    component: HIProductAuthenticationComponent,
    data: {
      title: "Authentication Page",
    },
  },
  // for sa.holostikapp.com only. When Deploying there uncomment it
  // {
  //   path: "auth-exp",
  //   component: ExperimentalAuthenticationComponent,
  //   data: {
  //     title: "Authentication Page",
  //   },
  // },
  {
    path: "pai",
    component: IssueNoProductAuthenticationComponent,
    data: {
      title: "Authentication Page",
    },
  },
  // for sa.holostikapp.com only. When Deploying there uncomment it
  // {
  //   path: "tn",
  //   component: TnProductAuthenticationComponent,
  //   data: {
  //     title: "Authentication Page",
  //   },
  // },
  {
    path: "od",
    component: MPPKVVCLAuthenticationComponent,
    data: {
      title: "Authentication Page",
    },
  },
  {
    path: "pa-wa",
    component: ProductAuthWaComponent,
    data: {
      title: "Authentication Page",
    },
  },
  {
    path: "tnc.html",
    component: TncComponent,
    data: {
      title: "TnC Page",
    },
  },
  {
    path: "",
    component: DefaultLayoutComponent,
    data: {
      title: "Home",
    },
    children: [
            {
              path: "holostik",
              loadChildren: () =>
                import("./views/dashboard/dashboard.module").then(
                  m => m.DashboardModule
                )
            },
      {
        path: "analytics",
        component: AnalyticsComponent,
        data: {
          title: "Analytics",
          type: "total",
        },
      },
      {
        // Same component as "analytics" above, driven by :type
        // ("authentic" | "suspected" | "duplicate" | "fake" |
        // "unverified") - see AnalyticsComponent.METRIC_CONFIGS. Kept as a
        // separate route
        // (rather than making "analytics" itself take an optional param)
        // so the existing bare /analytics link keeps working unchanged.
        path: "analytics/:type",
        component: AnalyticsComponent,
        data: {
          title: "Analytics",
        },
      },
      {
        path: "product-intelligence",
        component: ProductIntelligenceComponent,
        data: {
          title: "Product Intelligence",
        },
      },
      {
        path: "generated-qr-report",
        component: GeneratedQrReportComponent,
        data: {
          title: "Generated QR Report",
        },
      },
      {
        // Same component as "generated-qr-report" above, driven by :type
        // ("assigned" | "scrapped" | "deallocated" | "instock") - see
        // GeneratedQrReportComponent's REPORT_CONFIGS. Kept as a separate
        // route (rather than making "generated-qr-report" itself take an
        // optional param) so the existing bare link keeps working unchanged
        // - same reasoning as "analytics" / "analytics/:type" above.
        path: "generated-qr-report/:type",
        component: GeneratedQrReportComponent,
        data: {
          title: "QR Report",
        },
      },
      {
        path: "inventory-report",
        component: InventoryReportComponent,
        data: {
          title: "Inventory Report",
        },
      },
      {
        // Dashboard's Recent Alerts "View All".
        path: "recent-alerts",
        component: RecentAlertsReportComponent,
        data: {
          title: "Recent Alerts",
        },
      },
      {
        // No AuthGuardService: like the other dashboard pages above, this
        // isn't a role-master page, so CheckRouteUrl would reject it.
        path: "configuration",
        component: ConfigurationComponent,
        data: {
          title: "Configuration",
        },
      },
      {
        path: "masters",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./views/masters/masters.module").then((m) => m.MastersModule)
      },
      {
        path: "numberactive",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./views/numberActive/number-active.module").then(
            (m) => m.NumberActiveModule
          ),
      },
      {
        path: "transactions",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./views/transactions/transactions.module").then(
            (m) => m.TransactionsModule
          ),
      },
      {
        path: "reports",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./views/reports/reports.module").then((m) => m.ReportsModule)
      },
      {
        path: "dashboard",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./views/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: "dashboard1",
        canActivate: [AuthGuardService],
        loadChildren: () =>
          import("./views/dashboard/dashboard-new/dashboard-new.module").then(
            (m) => m.DashboardNewModule
          ),
      },
    ],
  },
  { path: "**", component: P404Component }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
